import { render, staticRenderFns } from "./Addblocker.vue?vue&type=template&id=507080d0&scoped=true&"
import script from "./Addblocker.vue?vue&type=script&lang=js&"
export * from "./Addblocker.vue?vue&type=script&lang=js&"
import style0 from "./Addblocker.vue?vue&type=style&index=0&id=507080d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507080d0",
  null
  
)

export default component.exports